import { getCustomData } from 'shared/components/App/Auth'

const showCustomerSwitcher = (): boolean => {
  return getCustomData('showCustomerSwitcher') ?? false
}

export default showCustomerSwitcher
